import(/* webpackMode: "eager", webpackExports: ["SubscriptionPlans"] */ "/root/repo/src/app/components/Payment/SubscriptionPlans.tsx");
